import { React, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import formStyles from "./Forms.module.css";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Modal, Divider } from "semantic-ui-react";
import Checkbox from "@mui/material/Checkbox";
import { Checkbox as SemanticCheckbox } from "semantic-ui-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { set } from "date-fns";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import Chip from "@mui/material/Chip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css"

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
function Forms() {
  const navigate = useNavigate();
  // Variable Declarations
  const [forms, setForms] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [fields, setFields] = useState([]);
  const [formSteps, setFormSteps] = useState([]);
  const [showAddFormModal, setShowAddFormModal] = useState(false);
  const [showDeleteFormModal, setShowDeleteFormModal] = useState(false);
  const [showUpdateFormModal, setShowUpdateFormModal] = useState(false);
  const [showAssignFormModal, setShowAssignFormModal] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [selectedMandatory, setSelectedMandatory] = useState([]);
  const [hasfields, setHasFields] = useState([]);
  const [hasmandatory, setHasMandatory] = useState([]);
  const [fieldStatus, setFieldStatus] = useState({});
  const [searchKeyword, setSearchKeyword] = useState("");
  const suggestedStepArray = [
    "Degree Selection",
    "Personal Information",
    "Personal Information 2",
    "Academic Information",
    "Additional Information",
    "References",
    "Payment",
  ];
  const [suggestedSteps, setSuggestedSteps] = useState(suggestedStepArray);

  //Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  const handleAssignSteps = () => {
    navigate(`/form-steps/${currentAppId}`);
  };

  // Session Storage handling
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getForms();
    } else {
      let filteredForms = forms.filter((form) => {
        const nameMatch =
          form.name && form.name.toLowerCase().includes(searchTerm);
        const descriptionMatch =
          form.description &&
          form.description.toLowerCase().includes(searchTerm);

        return nameMatch || descriptionMatch;
      });
      setForms(filteredForms);
    }
  };

  // GET Api calls
  // const getFields = async () => {
  //   const requestOptions = {
  //     method: "GET",
  //     headers: { "Content-Type": "application/json" },
  //   };
  //   await fetch(`${BASE_URL}/get_fields/`, requestOptions)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setFields(data.fields);
  //     })
  //     .catch((error) => console.log(error));
  // };

  const getForms = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(`${BASE_URL}/api/form/get_forms`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setForms(data.forms);
      })
      .catch((error) => console.log(error));
  };

  const getHasFields = async (id) => {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    await fetch(`${BASE_URL}/api/form/get-fields-in-form/${id}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        const temp_array = data.form_fields.map((element) => element.field_id);
        const temp_array2 = data.form_fields.map(
          (element) => element.is_required
        );
        setHasFields(temp_array);
        setHasMandatory(temp_array2);
      })
      .catch((error) => console.log(error));
  };

  const [formErrors, setFormErrors] = useState({
    name,
    description,
    formSteps,
  });

  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  // Add Form Functions
  const showFormAddModal = () => {
    setShowAddFormModal(true);
    setSuggestedSteps(suggestedStepArray);
  };
  const handleOkAddFormModal = () => {
    if (name && description && organization_id && formSteps.length > 0) {
      addForm();
      setShowAddFormModal(false);
    } else {
      callErrors(name, description, formSteps);
    }
  };
  const handleCancelAddFormModal = () => {
    setShowAddFormModal(false);
    setName("");
    setDescription("");
    setFormSteps([]);
    setFormErrors({
      name: "",
      description: "",
      formSteps: "",
    });
  };

  const callErrors = (nameError, descriptionError, formStepsError) => {
    const errors = {};
    if (nameError === "") {
      errors.name = " * Form name is Required";
    }
    if (descriptionError === "") {
      errors.description = " * Form Description is Required";
    }
    if (formStepsError.length <= 0) {
      errors.formSteps = "* Atleast One Form Step is Required";
    }

    setFormErrors(errors);
  };

  const addForm = () => {
    let data = { name, description, step_names: formSteps };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(`${BASE_URL}/api/form/add_form`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getForms();
        toast("Form Added Successfully");
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setName("");
        setDescription("");
        setFormSteps([]);
      });
  };

  // Delete Form Functions
  const showFormDeleteModal = () => {
    setShowDeleteFormModal(true);
  };
  const handleOkDeleteFormModal = () => {
    deleteForm();
    setShowDeleteFormModal(false);
  };
  const handleCancelDeleteFormModal = () => {
    setShowDeleteFormModal(false);
  };
  const deleteForm = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      `${BASE_URL}/api/form/delete_form/${currentAppId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        getForms();
        toast.success("Form Deleted Successfully");
      })
      .catch((error) => console.log(error));
  };

  const [toBeUpdated, setToBeUpdated] = useState();
  // Update Form Functions
  const showFormUpdateModal = () => {
    const formToBeUpdate = forms.filter((form) => form.id === currentAppId);
    setToBeUpdated(formToBeUpdate[0]);
    getFormStepsById();
    setShowUpdateFormModal(true);
  };

  const handleOkUpdateFormModal = () => {
    if (toBeUpdated.name && toBeUpdated.description && formSteps) {
      updateForm();
      setShowUpdateFormModal(false);
    } else {
      callErrors(toBeUpdated.name, toBeUpdated.description, formSteps);
    }
  };

  const handleCancelUpdateFormModal = () => {
    setShowUpdateFormModal(false);
    setName("");
    setDescription("");
    setFormSteps([]);
    setFormErrors({
      name: "",
      description: "",
      formSteps: "",
    });
  };

  const getFormStepsById = () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${BASE_URL}/api/form/get_form_steps/${currentAppId}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        console.log("data.steps: ");
        const stepNames = data.steps.map((item) => item.step_name);
        setFormSteps(stepNames);
        setSuggestedSteps(
          suggestedStepArray.filter(
            (suggestedStep) => !stepNames.includes(suggestedStep)
          )
        );
      })
      .catch((error) => console.log(error));
  };

  const updateForm = () => {
    let data = {
      id: toBeUpdated.id,
      name: toBeUpdated.name,
      description: toBeUpdated.description,
      step_names: formSteps,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(`${BASE_URL}/api/form/update_form`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getForms();
        toast.success("Form Updated Successfully");
      })
      .catch((error) => console.log(error));
  };

  // Assign Form Functions
  const showFormAssignModal = (id) => {
    getHasFields(id);
    setShowAssignFormModal(id);
  };
  const handleOkAssignFormModal = () => {
    assignForm(showAssignFormModal);
    setShowAssignFormModal(false);
  };
  const handleCancelAssignFormModal = () => {
    setShowAssignFormModal(false);
  };
  const assignForm = (id) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        form_id: id,
        fields: updatedFields,
      }),
    };
    fetch(`${BASE_URL}/api/form/assign-fields-to-form`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getForms();
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    setSelectedFields(hasfields);
    setSelectedMandatory(hasmandatory);
  }, [hasfields, hasmandatory]);

  useEffect(() => {
    // getFields();
    getForms();
  }, []);

  const handleSelectFields = (fieldId) => {
    setFieldStatus((prevFieldStatus) => ({
      ...prevFieldStatus,
      [fieldId]: !prevFieldStatus[fieldId],
    }));

    if (fieldStatus[fieldId] === 1) {
      handleRequired(fieldId);
    }
  };

  const handleRequired = (fieldId) => {
    setFieldStatus((prevFieldStatus) => ({
      ...prevFieldStatus,
      [fieldId]: prevFieldStatus[fieldId] === 1 ? 0 : 1,
    }));
  };
  const handleAddSteps = () => {
    setFormSteps([...formSteps, ""]);
    setFormErrors({ ...formErrors, formSteps: "" });
  };
  const addValueToStep = (value, index) => {
    formSteps[index] = value;
    setFormSteps([...formSteps]);
  };
  const handleRemoveStep = (step) => {
    const updatedFormSteps = formSteps.filter((item) => item !== step);
    setFormSteps(updatedFormSteps);
    if (suggestedStepArray.includes(step)) {
      const updatedSuggestedSteps = [...suggestedSteps, step];
      setSuggestedSteps(updatedSuggestedSteps);
    }
  };
  const updatedFields = Object.entries(fieldStatus).map(
    ([id, is_required]) => ({
      field_id: parseInt(id),
      is_required,
    })
  );
  const handleMoveStepUp = (index) => {
    if (index > 0) {
      const newFormSteps = [...formSteps];
      [newFormSteps[index - 1], newFormSteps[index]] = [
        newFormSteps[index],
        newFormSteps[index - 1],
      ];
      setFormSteps(newFormSteps);
    }
  };

  const handleMoveStepDown = (index) => {
    if (index < formSteps.length - 1) {
      const newFormSteps = [...formSteps];
      [newFormSteps[index], newFormSteps[index + 1]] = [
        newFormSteps[index + 1],
        newFormSteps[index],
      ];
      setFormSteps(newFormSteps);
    }
  };
  const handleTagClick = (step) => {
    setFormSteps([...formSteps, step]);
    setSuggestedSteps(
      suggestedSteps.filter((suggestedStep) => suggestedStep !== step)
    );
  };
  const handleCopyForm = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ form_id: currentAppId }),
    };
    fetch(`${BASE_URL}/api/form/copy_form`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          getForms();
          toast.success("Form Copied Successfully");
        }
      })
      .catch((error) => console.log(error));
  };

  // Rows & Columns Injection
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Form Name", accessor: "form_name", align: "left" },
    { Header: "Description", accessor: "description", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    forms.length > 0
      ? forms.map((form, index) => ({
          serial: index + 1,
          form_name: form.name,
          description: form.description,
          actions: (
            <>
              <div>
                <IconButton
                  aria-label="more"
                  id={`long-button-${index}`}
                  aria-controls={opens ? "long-menu" : undefined}
                  aria-expanded={opens ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={(event) => handleClick(event, form.id)}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={anchorEl}
                  open={opens}
                  onClose={handleClose}
                >
                  <MenuItem onClick={showFormDeleteModal}>
                    <DeleteIcon style={{ marginRight: "15px", color: "red" }} />{" "}
                    Delete
                  </MenuItem>
                  <MenuItem onClick={showFormUpdateModal}>
                    <EditIcon style={{ marginRight: "15px", color: "green" }} />{" "}
                    Edit
                  </MenuItem>
                  <MenuItem onClick={handleAssignSteps}>
                    <AssignmentIcon
                      style={{ marginRight: "15px", color: "blue" }}
                    />{" "}
                    Make Template
                  </MenuItem>
                  <MenuItem onClick={handleCopyForm}>
                    <ContentCopyIcon
                      style={{ marginRight: "15px", color: "blue" }}
                    />{" "}
                    Make a Copy
                  </MenuItem>
                </Menu>
              </div>
            </>
          ),
        }))
      : [
          {
            serial: null,
            form_name: null,
            description: null,
            actions: null,
          },
        ];
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card
              className="mt-5 card1"
             
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper
                      component="form"
                       className="search-paper"
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon
                          className="search-icon"
                      />
                    </Paper>
                  </Stack>
                  <Button
                    variant="filled"
                    endIcon={
                      <AddIcon
                        className="add-icon"
                      />
                    }
                    onClick={showFormAddModal}
                    className="add-button"
                  >
                    Add
                  </Button>
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {forms && forms.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src="nodata.png"
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog
        fullScreen={fullScreen}
        open={showAddFormModal}
        onClose={handleCancelAddFormModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Add Form"}</DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Form Name</label>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Form Name"
                  required
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.name}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Description</label>
                <input
                  name="description"
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Description"
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.description}</div>
            </div>
            <div className="col-md-12 mt-4">
              <h3>Steps:</h3>
            </div>
            <div className="col-md-2">
              <button className="btn btn-primary mt-4" onClick={handleAddSteps}>
                Add
              </button>
            </div>
            <div className="col-md-10"></div>
            <div className="col-md-12 mt-3">
              {suggestedSteps.map((step, index) => (
                <Chip
                  key={index}
                  label={step}
                  style={{ margin: "5px" }}
                  onClick={() => handleTagClick(step)}
                />
              ))}
              <hr />
            </div>
            <div style={{ color: "red" }}>{formErrors.formSteps}</div>
            {formSteps.map((step, index) => (
              <div className="row " key={index}>
                <div className="col-md-8">
                  <div className="form-outline mt-3">
                    <label>Step Name</label>
                    <input
                      name="step"
                      type="text"
                      value={step}
                      onChange={(e) => addValueToStep(e.target.value, index)}
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Step Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 mt-4">
                  <button
                    className="btn btn-secondary mt-4"
                    onClick={() => handleMoveStepUp(index)}
                    disabled={index === 0}
                  >
                    <ArrowUpwardIcon />
                  </button>
                  <button
                    className="btn btn-secondary mt-4"
                    style={{ marginLeft: "10px" }}
                    onClick={() => handleMoveStepDown(index)}
                    disabled={index === formSteps.length - 1}
                  >
                    <ArrowDownwardIcon />
                  </button>
                  <button
                    className="btn btn-danger mt-4"
                    style={{ marginLeft: "10px" }}
                    onClick={() => handleRemoveStep(step)}
                  >
                    <DeleteIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelAddFormModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkAddFormModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={showDeleteFormModal}
        onClose={handleCancelDeleteFormModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Delete Form"}</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this Form?
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelDeleteFormModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkDeleteFormModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={showUpdateFormModal}
        onClose={handleCancelUpdateFormModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Update Form"}</DialogTitle>
        <DialogContent>
          {toBeUpdated && (
            <div className="row">
              <div className="col-md-6">
                <div className="form-outline mt-3">
                  <label>Form Name</label>
                  <input
                    name="name"
                    type="text"
                    value={toBeUpdated.name}
                    onChange={(e) =>
                      setToBeUpdated({ ...toBeUpdated, name: e.target.value })
                    }
                    onFocus={handleFocus}
                    className="form-control form-control-lg"
                    placeholder="Enter Form Name"
                    required
                  />
                </div>
                <div style={{ color: "red" }}>{formErrors.name}</div>
              </div>
              <div className="col-md-6">
                <div className="form-outline mt-3">
                  <label>Description</label>
                  <input
                    name="name"
                    type="text"
                    value={toBeUpdated.description}
                    onChange={(e) =>
                      setToBeUpdated({
                        ...toBeUpdated,
                        description: e.target.value,
                      })
                    }
                    onFocus={handleFocus}
                    className="form-control form-control-lg"
                    placeholder="Enter Description"
                  />
                </div>
                <div style={{ color: "red" }}>{formErrors.description}</div>
              </div>
              <div className="col-md-12 mt-4">
                <h3>Steps:</h3>
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-primary mt-4"
                  onClick={handleAddSteps}
                >
                  Add
                </button>
              </div>
              <div className="col-md-10"></div>
              <div className="col-md-12 mt-3">
                {suggestedSteps.map((step, index) => (
                  <Chip
                    key={index}
                    label={step}
                    style={{ margin: "5px" }}
                    onClick={() => handleTagClick(step)}
                  />
                ))}
                <hr />
              </div>
              {formSteps.map((step, index) => (
                <div className="row " key={index}>
                  <div className="col-md-8">
                    <div className="form-outline mt-3">
                      <label>Step Name</label>
                      <input
                        name="step"
                        type="text"
                        value={step}
                        onChange={(e) => addValueToStep(e.target.value, index)}
                        onFocus={handleFocus}
                        className="form-control form-control-lg"
                        placeholder="Enter Step Name"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4 mt-4">
                    <button
                      className="btn btn-secondary mt-4"
                      onClick={() => handleMoveStepUp(index)}
                      disabled={index === 0}
                    >
                      <ArrowUpwardIcon />
                    </button>
                    <button
                      className="btn btn-secondary mt-4"
                      style={{ marginLeft: "10px" }}
                      onClick={() => handleMoveStepDown(index)}
                      disabled={index === formSteps.length - 1}
                    >
                      <ArrowDownwardIcon />
                    </button>
                    <button
                      className="btn btn-danger mt-4"
                      style={{ marginLeft: "10px" }}
                      onClick={() => handleRemoveStep(step)}
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
        {/* <DialogContent>
          <div className="form-outline mt-3">
            <label>Form Name</label>
            <input
              name="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="form-control form-control-lg"
              placeholder="Enter Form Name"
            />
          </div>

          <div className="form-outline mt-3">
            <label>Description</label>
            <input
              name="name"
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="form-control form-control-lg"
              placeholder="Enter Description"
            />
          </div>
        </DialogContent> */}
        <DialogActions>
          <Button negative onClick={handleCancelUpdateFormModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkUpdateFormModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={showAssignFormModal}
        onClose={handleCancelAssignFormModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Assign Form"}</DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col md-2 text-center">
              <h6>Select</h6>
            </div>
            <div className="col md-3"></div>
            <div className="col md-2 text-center">
              <h6>Users</h6>
            </div>
            <div className="col md-3"></div>
            <div className="col md-2 text-center">
              <h6>is-Mandatory</h6>
            </div>
            &nbsp;
            <Divider></Divider>
          </div>

          {fields.map((field) => (
            <div className="row" key={field.id}>
              <div className="col md-2 text-center">
                <Checkbox
                  checked={fieldStatus[field.id] === 1}
                  onChange={() => {
                    handleSelectFields(field.id);
                    handleRequired(field.id);
                  }}
                />
              </div>
              <div className="col md-3"></div>
              <div className="col md-2 text-center">
                <h6>{field.name}</h6>
              </div>
              <div className="col md-3"></div>
              <div className="col md-2 text-center">
                <SemanticCheckbox
                  slider
                  checked={fieldStatus[field.id] === 1}
                  onChange={() => {
                    handleSelectFields(field.id);
                    handleRequired(field.id);
                  }}
                />
              </div>
              &nbsp;
              <Divider></Divider>
            </div>
          ))}
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelAssignFormModal}>
            Disagree
          </Button>
          <Button positive onClick={handleOkAssignFormModal}>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Forms;
